<template>
  <div>
    <AdminAppBar :route="'/admin/new/'+$route.params.type"> {{ $route.params.type.charAt(0).toUpperCase() + $route.params.type.slice(1)}} </AdminAppBar>
    <div class="page-content header-clear-small">
      <div class="card card-style">
        <div class="content">
          <h3>{{ $route.params.type.charAt(0).toUpperCase() + $route.params.type.slice(1)}} Lists</h3>
          <p>To get more contact information simply tap the "Edit" button</p>
          <div class="user-slider">
            <div v-for="project in projects.data" :key="project.id" class="user-left">
              <div class="d-flex">
                <div><img src="/images/pictures/faces/default.png" class="mr-3 rounded-circle shadow-l" width="50"></div>
                <div>
                  <h5 class="mt-1 mb-0">{{ project.project }}</h5>
                  <p class="font-10 mt-n1 color-red2-dark">{{ project.details+"\n" }} Contribution Amount: ${{ project.amount }}{{ project.contribution_amount }} </p>
                </div>
                <router-link :to="'/admin/chat/'+$route.params.type+'/'+project.id" class="ml-auto"><span class="next-slide-user badge bg-red2-dark mt-2 p-2 font-8">Updates</span></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AdminAppBar from "@/components/admin/AdminAppBar";
import axios from "axios";
import global from "@/mixins/global";
export default {
  mixins: [global],
  mounted() {
    this.fetchData(this.$route.params.type)
  },
  data(){
    return {
      projects: []
    }
  },
  name: "AdminProjectList",
    components: {AdminAppBar},
    methods: {
      fetchData(type){
        axios.get(this.base_url+type + (type === "farming" ? "" : "s"), this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
          this.projects = response.data
        }).catch(error=>{this.error = error})
      }
    }
  }
</script>

<style scoped>

</style>